module.exports = __webpack_public_path__ + "img/czar-lisbon-hotel-czar-lisbon-amazing-evolution.6601a8e4.jpg";